export { D as DOCUMENT_EVENT_NAME_CLICK, a as DOCUMENT_EVENT_NAME_MOUSEDOWN, u as useDocumentEvent } from '../../chunks/hook-D51BbGUy.js';
import 'react';
//# sourceMappingURL=index.js.map
